import type React from "react"
import { Navigate, Route, Routes } from "react-router-dom"
import { Dashboard } from "~/modules/dashboard/Dashboard"
import Users from "~/modules/users/Users"
import { MyWorksheets } from "~/modules/worksheets"
import Generator from "~/modules/worksheets/Generator"
import Settings from "../settings/Settings"
import Subscription from "../subscriptions/Subscription"
import BuyNewSubscriptionWrapper from "../subscriptions/paymentViews/BuyNewSubscriptionWrapper"
import ChangePaymentMethod from "../subscriptions/paymentViews/ChangePaymentMethod"
import ChangePaymentMethodSuccess from "../subscriptions/paymentViews/ChangePaymentMethodSuccess"
import ChangePeriodicity from "../subscriptions/paymentViews/ChangePeriodicity"
import PaymentSuccess from "../subscriptions/paymentViews/PaymentSuccess"
import SetupSuccess from "../subscriptions/paymentViews/SetupSuccess"
import TrialPay from "../subscriptions/paymentViews/TrialPay"
import CancelSubscription from "../subscriptions/personal/CancelSubscription"
import CancelSubscriptionSuccess from "../subscriptions/personal/CancelSubscriptionSuccess"
import SubscriptionSchoolCancel from "../subscriptions/school/SubscriptionSchoolCancel"
import SubscriptionSchoolCancelSuccess from "../subscriptions/school/SubscriptionSchoolCancelSuccess"

type AuthRoutesProps = {}

export const AuthRoutes: React.FC<AuthRoutesProps> = () => {
  return (
    <Routes>
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/my-worksheets" element={<MyWorksheets />} />
      <Route path="/generator/*" element={<Generator />} />
      <Route
        path="/ny-generator/*"
        element={<Navigate to="/generator/mathematics" replace />}
      />
      <Route path="/users/*" element={<Users />} />
      <Route path="/settings" element={<Settings />} />

      {/* SUBSCRIPTION ROUTES */}
      <Route path="/subscription" element={<Subscription />} />
      <Route path="/subscription/cancel" element={<CancelSubscription />} />
      <Route
        path="/subscription/cancel-success"
        element={<CancelSubscriptionSuccess />}
      />
      <Route path="/subscription/trial-pay" element={<TrialPay />} />
      <Route
        path="/subscription/buy-new-subscription"
        element={<BuyNewSubscriptionWrapper />}
      />
      <Route path="/subscription/setup-success" element={<SetupSuccess />} />
      <Route
        path="/subscription/payment-success"
        element={<PaymentSuccess />}
      />
      <Route
        path="/subscription/change-payment-method"
        element={<ChangePaymentMethod />}
      />
      <Route
        path="/subscription/change-payment-method-success"
        element={<ChangePaymentMethodSuccess />}
      />
      <Route
        path="/subscription/change-periodicity"
        element={<ChangePeriodicity />}
      />
      <Route
        path="/subscription/school-cancel"
        element={<SubscriptionSchoolCancel />}
      />
      <Route
        path="/subscription/school-cancel-success"
        element={<SubscriptionSchoolCancelSuccess />}
      />
      <Route
        path="*"
        element={<Navigate to="/generator/mathematics" replace />}
      />
    </Routes>
  )
}
